import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { GameTypeButton } from '~molecules/GameTypeButton';
import { useActiveGameSelector, useGameBalanceSelector } from '~slices/games';
import { BalanceCard } from '~atoms/BalanceCard';
import { useStructuredSelector } from '~hooks';
import { betslipDataSelector } from '~slices/betslip';
import { toCapitalize } from '~utils/toCapitalize';
import { usePlayerAccountsDataSelector, } from '~slices/playerAccounts';
import { useStyles } from './TopUpTab.styles';
var DEFAULT_TOP_UP_VALUE = 10;
export var TopUpTab = function () {
    var _a;
    var classes = useStyles();
    var t = useTranslation('tip-game').t;
    var _b = useState(null), activeCard = _b[0], setActiveCard = _b[1];
    var _c = useState(DEFAULT_TOP_UP_VALUE), topUpValue = _c[0], setTopUpValue = _c[1];
    var _d = useState(DEFAULT_TOP_UP_VALUE / 10), labelValue = _d[0], setLabelValue = _d[1];
    var search = useLocation().search;
    var params = new URLSearchParams(search);
    var gameTypeParams = params.get('type');
    var _e = useStructuredSelector({
        betslip: betslipDataSelector,
        activeGame: useActiveGameSelector,
        gameBalance: useGameBalanceSelector,
        playerAccounts: usePlayerAccountsDataSelector,
    }), betslip = _e.betslip, activeGame = _e.activeGame, gameBalance = _e.gameBalance, playerAccounts = _e.playerAccounts;
    var ticketOffer = betslip.to;
    var currency = (_a = ticketOffer === null || ticketOffer === void 0 ? void 0 : ticketOffer.cu) !== null && _a !== void 0 ? _a : 'NONE';
    useEffect(function () {
        var activeAccount = playerAccounts.find(function (account) { return account.type !== 'STATUS'; });
        if (activeAccount) {
            setActiveCard(activeAccount.type);
        }
    }, [playerAccounts]);
    useEffect(function () {
        if (gameTypeParams && gameBalance) {
            var gameBalanceValue = (gameBalance === null || gameBalance === void 0 ? void 0 : gameBalance.balance) !== undefined
                ? gameBalance.balance
                : gameBalance === null || gameBalance === void 0 ? void 0 : gameBalance.startCredits;
            var calculatedRoundedValue = Math.ceil((ticketOffer === null || ticketOffer === void 0 ? void 0 : ticketOffer.wa) ? (ticketOffer === null || ticketOffer === void 0 ? void 0 : ticketOffer.wa) - gameBalanceValue : 0);
            if (calculatedRoundedValue > 0) {
                setTopUpValue(calculatedRoundedValue);
                setLabelValue(calculatedRoundedValue / 10);
            }
        }
    }, [ticketOffer === null || ticketOffer === void 0 ? void 0 : ticketOffer.wa, search, gameBalance]);
    var onBalanceCardClick = function (type) {
        setActiveCard(type);
    };
    return (React.createElement("div", { className: classes.container },
        React.createElement("div", null,
            React.createElement("div", { className: classes.balanceCardWrapper }, playerAccounts.map(function (account, index) { return (React.createElement(BalanceCard, { key: index, type: account.type, currency: account.currency, isActive: activeCard === account.type, balance: account.balance, onClick: account.type === 'STATUS'
                    ? undefined
                    : function () { return onBalanceCardClick(account.type); } })); })),
            React.createElement("div", { className: classes.gameTypeButtons }, activeGame && (React.createElement(GameTypeButton, { name: activeGame.name, isActiveButton: true, isActiveGame: true, creditBalance: gameBalance === null || gameBalance === void 0 ? void 0 : gameBalance.startCredits, playerBalance: gameBalance === null || gameBalance === void 0 ? void 0 : gameBalance.rankingBalance, tournament: activeGame.tournament }))),
            React.createElement("div", { className: classes.description }, activeCard
                ? t('payments.you-are-topping-up-game-by-credits', {
                    gameType: toCapitalize((activeGame === null || activeGame === void 0 ? void 0 : activeGame.name) || ''),
                    credits: topUpValue,
                    currency: "".concat(labelValue, " ").concat(currency),
                    balanceType: toCapitalize(activeCard !== null && activeCard !== void 0 ? activeCard : ''),
                })
                : null))));
};
